import { STRAPI_API_TOKEN, STRAPI_API_URL } from "@/src/const";
import { Log } from "@/src/util/log";

export type StrapiApiServiceType<T> = {
  success: boolean;
  status: number;
  response?: T;
  error?: any;
};

export async function get<T>(
  id?: string,
  locale?: string,
  filter?: string,
  pathOverride?: string,
  populateOverride?: string
): Promise<StrapiApiServiceType<T>> {
  const _locale = (locale ?? "en").toLowerCase();
  const url = pathOverride
    ? `${STRAPI_API_URL}/${pathOverride}`
    : `${STRAPI_API_URL}/${id}?${populateOverride ?? "populate=deep"}&locale=${_locale}${filter ? `&${filter}` : ""}`;

  const returnResponse = (
    toResolve: StrapiApiServiceType<T>,
    resolve: (value: StrapiApiServiceType<T> | PromiseLike<StrapiApiServiceType<T>>) => void
  ) => {
    Log.logToConsoleDebug("StrapiService.ts", "STRAPI API REQUEST", [url, "GET", toResolve]);

    if (!toResolve.success && toResolve.status !== 404) {
      Log.logToProvider(Log.LogLevel.ERROR, "StrapiService.ts", "API REQUEST ERROR", [url, "GET", toResolve]);
    }

    resolve(toResolve);
  };

  return await new Promise(async (resolve) => {
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: `bearer ${STRAPI_API_TOKEN}`,
      },
    })
      .then((response) => {
        const { status } = response;
        switch (status) {
          case 200:
            response.json().then((response) => {
              returnResponse({ success: true, status, response }, resolve);
              return;
            });
            return;
          default:
            response.text().then((response) => {
              returnResponse({ success: false, status, error: response }, resolve);
            });
            return;
        }
      })
      .catch((error) => {
        returnResponse({ success: false, status: 500, error: error.toString() }, resolve);
      });
  });
}
